//React
import React from 'react'
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myProfileAction from '../action/myProfileAction';
import * as myProofAction from '../action/myProofAction';


//Material-ui
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Checkbox from '@material-ui/core/Checkbox';


//Part
import PartPageTitle from './PartPageTitle';



class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      personWant: false,
      incomeWant: false,
      photoWant: false,
      singleWant: false,
      creditWant: false,
    }
  }

  componentDidMount() {
    document.title = '希望する証明書 - パートナーズ';
    window.scrollTo(0, 0);

    this._prop2state();

  }


  _prop2state() {
    let proof = this.props.my.proof;
    this.setState({
      personWant: (proof.personWant === 1) ? true : false,
      incomeWant: (proof.incomeWant === 1) ? true : false,
      photoWant: (proof.photoWant === 1) ? true : false,
      singleWant: (proof.singleWant === 1) ? true : false,
      creditWant: (proof.creditWant === 1) ? true : false,
    })
  }

  _saveSubmit() {
    this.props.myProofWantEdit(
      (this.state.personWant) ? 1 : 0,
      (this.state.incomeWant) ? 1 : 0,
      (this.state.photoWant) ? 1 : 0,
      (this.state.singleWant) ? 1 : 0,
      (this.state.creditWant) ? 1 : 0,
      () => this.props.history.push('/my/#myProofWant')
    )
  }


  render() {

    return (
      <div style={{maxWidth:'600px', margin:'auto'}}>
        <PartPageTitle
          title={'希望する証明書'}
          onback={ '/my/' }
          helpType={ 'category' }
          helpFilter={ 'proof' }
        />

        <div style={{margin:'10px'}}>
          <Box boxShadow={2} style={{background:'#FFF'}}>
            <div style={{padding:'10px'}}>
              <div style={{ display:'flex',flexDirection:'row'}}>
                  <Checkbox
                    checked={this.state.personWant}
                    onChange={ () => this.setState({personWant: (this.state.personWant) ? false : true}) }
                  />
                  <h2>
                    本人証明
                  </h2>
              </div>
              <div>
                ご本人様である、プロフィールの年齢が正しい、未成年者ではない事の証明。
              </div>
            </div>

            <div style={{padding:'10px'}}>
              <div style={{ display:'flex',flexDirection:'row'}}>
                <Checkbox
                  checked={this.state.photoWant}
                  onChange={ () => this.setState({photoWant: (this.state.photoWant) ? false : true}) }
                />
                <h2>
                  写真証明
                </h2>
              </div>

              <div>
                メイン写真がご本人様のお写真であることの証明 。
                <div>(メイン写真に正面を向いてはっきりとお顔の確認できる画像を掲載されている方のみ)</div>
              </div>
            </div>

            <div style={{padding:'10px'}}>
              <div style={{ display:'flex',flexDirection:'row'}}>
                <Checkbox
                  checked={this.state.incomeWant}
                  onChange={ () => this.setState({incomeWant: (this.state.incomeWant) ? false : true}) }
                />
                <h2>
                  収入証明
                </h2>
              </div>
              <div>
                プロフィールに記載された年収が昨年度の年収と一致していることの証明 。
              </div>
            </div>

            <div style={{padding:'10px'}}>
              <div style={{ display:'flex',flexDirection:'row'}}>
                <Checkbox
                  checked={this.state.singleWant}
                  onChange={ () => this.setState({singleWant: (this.state.singleWant) ? false : true}) }
                />
                <h2>
                  独身証明
                </h2>
              </div>
              <div>
                独身者であることの証明。
              </div>
            </div>

            <div style={{padding:'15px'}} align='center'>
              <Button
                variant="contained"
                color='primary'
                onClick={ () => this._saveSubmit() }
                style={{minWidth: '240px', fontSize:'1.2em'}}
              >
                保存する
              </Button>
            </div>

          </Box>
        </div>


      </div>

    )

  }
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myProfileAction,
    ...myProofAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
